import { CloseOutlined } from '@ant-design/icons';
import { Flex, Image } from 'antd';
export const PhotoDisplay = ({ file, onRemove }) => (
  // console.log('file', file),
  <div className="relative group">
    <Image
      src={file.url}
      alt={file.name}
      width={'100%'}
      height={'200px'}
      className="object-contain object-center rounded-md bg-gray-200"
      preview={true}
    />
    <div className="absolute top-2 right-2">
      <CloseOutlined
        className="text-white hover:text-gray-200 cursor-pointer bg-black/50 p-1 rounded-full"
        onClick={() => onRemove(file.id)}
      />
    </div>
    <div className="absolute bottom-0 left-0 right-0 bg-black/50 text-white text-xs p-2">
      {file.fileName}
    </div>
  </div>
);